import history from './history'

export default history



// WEBPACK FOOTER //
// ./src/legacy/containers/History/index.js